import type { ReportEvent } from '@/types/report';
import { moveOrderedItem, type ReportOrderPlacement } from './moveOrderedItem';

function orderedPromptIds(events: ReportEvent[]): string[] {
    const positionByPromptId = new Map(
        events.map((event) => [event.promptId, event.promptPosition]),
    );
    return Array.from(positionByPromptId.keys()).sort(
        (first, second) =>
            positionByPromptId.get(first)! - positionByPromptId.get(second)!,
    );
}

export function moveReportPrompt(
    events: ReportEvent[],
    sourcePromptId: string,
    targetPromptId: string,
    placement: ReportOrderPlacement,
): ReportEvent[] {
    const reorderedPromptIds = moveOrderedItem(
        orderedPromptIds(events),
        (promptId) => promptId === sourcePromptId,
        (promptId) => promptId === targetPromptId,
        placement,
    );
    const positionByPromptId = new Map(
        reorderedPromptIds.map((promptId, position) => [promptId, position]),
    );
    return events.map((event) => {
        const position = positionByPromptId.get(event.promptId);
        return position === undefined || position === event.promptPosition
            ? event
            : { ...event, promptPosition: position };
    });
}
